import React from 'react';
import { connect } from 'react-redux';

import ChangePasswordForm from '../../components/Forms/ChangePasswordForm';
import Aux from '../../hoc/NoParent';
import Spinner from '../../components/UI/Spinner';

import { changePassword } from '../../store/actions/index';

const changePasswordComponent = props => {

    const { loading, onSubmitForm } = props;

    if(loading === true) return <Spinner />;
    
    return (
        <Aux>
            <ChangePasswordForm onSubmit={({ old_password, new_password, new_password_confirm}) => { onSubmitForm(old_password, new_password, new_password_confirm, this.props.token)}} />
        </Aux>
    );
};

const mapStateToProps = (state) => {
    return {
        token: state.auth.token, 
        loading: state.account.loading, 
        error: state.account.error 
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        onSubmitForm: (old_password, new_password, new_password_confirm, token) => dispatch(changePassword(old_password, new_password, new_password_confirm, token))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(changePasswordComponent);